const StatusList = [
    { id: 'active', name: 'Active' },
    { id: 'inactive', name: 'Inactive' }
]

export const statusModel = { StatusList }